import { JobPostWrapper } from "../types";
import { JobContactInfo } from "./JobContactInfo";
import { JobContentSections } from "./JobContentSections";
import { JobDetailsCards } from "./JobDetailsCards";
import { JobApplicationInfo } from "./JobApplicationInfo";

export default function JobDetailsTabContent({ jobPost }: JobPostWrapper) {
  return (
    <div className="flex flex-col">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="col-span-1 md:col-span-4 mt-12">
          <JobDetailsCards jobPost={jobPost} />
        </div>
        <div className="col-span-1 md:col-span-8 mt-8">
          <JobContentSections jobPost={jobPost} />
          <JobContactInfo jobPost={jobPost} />
          <JobApplicationInfo jobPost={jobPost} />
        </div>
      </div>
    </div>
  );
}
